import { httpRequest } from "../../../utils/HttpRequest";
import { IPage, ISearchPage } from "../../../types/ScmTypes";
export interface IStockRealInventoryFields {
    availableStock?: number,    // 0,
    averageAmount?: number,    // 0,
    averagePurchasePrice?: number,    // 0,
    brandCode?: string,    // "",
    brandName?: string,    // "",
    id?: string,    // "",
    inventoryInitial?: number,    // 0,
    inventoryNum?: number,    // 0,
    inventoryOccupied?: number,    // 0,
    lateSalePrice?: number,    // 0,
    latestAmount?: number,    // 0,
    latestPurPrice?: number,    // 0,
    limitLower?: number,    // 0,
    limitUpper?: number,    // 0,
    madeFrom?: string,    // "",
    materialCode?: string,    // "",
    materialName?: string,    // "",
    model?: string,    // "",
    nameEn?: string,    // "",
    purchasePrice?: number,    // 0,
    replaceCode?: string,    // "",
    retailPrice?: number,    // 0,
    shelfCode?: string,    // "",
    shelfId?: string,    // "",
    typeCode?: string,    // "",
    typeName?: string,    // "",
    unitCode?: string,    // "",
    unitName?: string,    // "",
    warehouseCode?: string,    // "",
    warehouseName?: string,    // ""
    [key: string]: any

}
export type IStockRealInventorySearch = IStockRealInventoryFields & ISearchPage;
export type IStockRealInventoryDetail = IStockRealInventoryFields
export interface IInventoryTotal {
    averageAmount: number,  // 0,
    type: number,  // 8,
    latestAmountTotal: number,  // 4250,
    total: number,  // 65
}
export interface IList {
    hitCount: boolean,
    optimizeCountSql: boolean,
    total: number,
    current: number,
    pageNum: number,
    size: number,
    orders: any,
    isSearchCount: boolean,
    records: IStockRealInventoryDetail[]
}
export interface IStockRealInventoryList {
    inventoryTotal: IInventoryTotal,
    list: IList
}
export interface IOccupyFidles {
    materialCode?: string // "",
    shopId?: string // ""
    occupy?: string // ""
}
export type IOccupySearch = IOccupyFidles & ISearchPage;
export interface IOccupyDetails {
    code?: string, // "TJHYWX202106030002"
    createTime?: string, // "2021-06-0"
    customerCode?: string, // "CUS-M-00002407"
    customerName?: string, // "华宇"
    detailsId?: string, // "c5feae1d69054fc99c87d28c4dbd6fbb"
    id?: string, // "56f2435d9685482c862bddfb3896b931"
    materialCode?: string, // "880788"
    num?: string, // 1
    shopId?: string, // "2d0351d2cf90973a4467e76ee5b57582"
    shopName?: string, // "天津红岩品牌部"
    status?: string, // "maintenance.create"
    type?: string, // "维修工单"
}
export interface IRelocation {
    materialCode?: string,// "",
    materialName?: string,// "",
    relocationNum?: string,// 0,
    shelfCode?: string,// "",
    shelfCodeNew?: string,// "",
    shelfId?: string,// "",
    shelfIdNew?: string,// "",
    shopId?: string,// "",
    shopName?: string,// "",
    stockId?: string,// "",
    warehouseCode?: string,// "",
    warehouseCodeNew?: string,// "",
    warehouseName?: string,// "",
    warehouseNameNew?: string,// ""
}
export interface IRelocationDetail {
    details: IRelocation[]
}

//转移记录
export interface IRecordsFields {
    startTime?: string,
    endTime?: string,
    materialCode?: string,
    stockId?: string
}
export type IRecordsSearch = IRecordsFields & ISearchPage
export interface IRecordsDetail {
    id?: string, // "",
    materialCode?: string, // "",
    materialName?: string, // "",
    relocationNum?: string, // 0,
    shelfCode?: string, // "",
    shelfCodeNew?: string, // "",
    shelfId?: string, // "",
    shelfIdNew?: string, // "",
    shopId?: string, // "",
    shopName?: string, // "",
    stockId?: string, // "",
    warehouseCode?: string, // "",
    warehouseCodeNew?: string, // "",
    warehouseName?: string, // "",
    warehouseNameNew?: string, // ""
}
export interface IStockFindDetails {
    // 商品编码：
    materialCode: string
    // 商品名称：
    materialName: string
    // 仓库名称: 
    warehouseName: string
    // 仓库编号: 
    warehouseCode: string
    // 货位编号：
    shelfCode: string
    // 入库数量：
    inventoryNum: number
    purchasePrice: number,
    retailPrice: number,
    // 初始库存数量：
    inventoryInitial: number
    // 占用库存数量：
    inventoryOccupied: number
    // 可用库存数量：
    availableStock: number
    // 入库单价：
    latestPurPrice: number
    // 最新销价：
    lateSalePrice: number
    // 入库金额：
    totalAmount: number
    // 供应商编号：
    supplierCode: string
    // 供应商名称：
    supplierName: string
    // 采购单号：
    purchaseCode: string
    // 入库日期：
    stockIoTime: string
    // 替换编号：
    replaceCode: string
    inventoryQuantity?: number,
    id: string
    [key: string]: any
}
class StockRealInventoryService {
    //库存查询
    async page(searchVo: IStockRealInventorySearch) {
        const apiUrl = "/zzw-vrm/stock/findPage";
        return await httpRequest.post<IStockRealInventoryList[]>(apiUrl, searchVo);
    }
    //分页查询
    async pages(searchVo: IStockRealInventorySearch) {
        const apiUrl = "/zzw-vrm/stock/findPages";
        return await httpRequest.post<IPage<IStockRealInventoryDetail>>(apiUrl, searchVo);
    }
    //采购明细查询
    async findPage(searchVo: IStockRealInventorySearch) {
        const apiUrl = "/zzw-vrm/stock/details/findPage";
        return await httpRequest.post<IPage<IStockFindDetails>>(apiUrl, searchVo);
    }
    //采购明细单条单据对应价格查询
    async findId(stockId: string) {
        const apiUrl = `/zzw-vrm/stock/details/findId/${stockId}`;
        return await httpRequest.get<IStockFindDetails>(apiUrl);
    }
    //根据ID查询
    async one(id: string) {
        const apiUrl = `/zzw-vrm/purchase/findById/${id}`;
        return await httpRequest.get<IStockRealInventoryFields>(apiUrl);
    }
    //导出
    async export(params: IStockRealInventorySearch) {
        const apiUrl = "/zzw-vrm/stock/export";
        return await httpRequest.postFile(apiUrl, params, { timeout: 300000 });
    }
    //占用明细查看
    // async occupy(searchVo: IOccupySearch) {
    //     const apiUrl = `/zzw-vrm/occupy/findPage`;
    //     return await httpRequest.post<IPage<IOccupyDetails>>(apiUrl, searchVo);
    // }

    //占用明细查看
    async occupy(searchVo: IOccupySearch) {
        const apiUrl = `/zzw-vrm/realInventorys/purchaseSaleStorageDeatil`;
        return await httpRequest.post<IRecordsDetail[]>(apiUrl, searchVo);
    }
    //移库
    async relocation(searchVo: IRelocationDetail) {
        const apiUrl = `/zzw-vrm/stock/relocation`;
        return await httpRequest.post<boolean>(apiUrl, searchVo);
    }
    //移库记录查看
    async records(searchVo: IRecordsSearch) {
        const apiUrl = `/zzw-vrm/records/page`;
        return await httpRequest.post<IPage<IRecordsDetail>>(apiUrl, searchVo);
    }
    //移库还原接口
    async reduction(id: string) {
        const apiUrl = `/zzw-vrm/records/reduction/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
}

export const stockRealInventoryService = new StockRealInventoryService();